import consentService from '../../components/consents/consentsService.js'

const state = {
  consents: [],
  consent: {},
}

const getters = {
  consents: state => {
    return state.consents
  },
  consent: state => {
    return state.consent
  },
}

const mutations = {
  'SET_CONSENTS_ARRAY': (state, consents) => {
    state.consents = consents
  },

  'SET_CONSENT': (state, consent) => {
    state.consent = consent
  },

  'PUSH_CONSENT': (state, consent) => {
    state.consents.push(consent);
  },

  'REMOVE_CONSENT': (state, idx) => {
    state.consents.splice(idx, 1);
  }
}

const actions = {
  fetchAllConsents: ({
    commit
  }) => {
    consentService.fetchConsents().then(result => {
      let data = result.data

      const consents = data.consentsDTO

      commit('SET_CONSENTS_ARRAY', consents)
    })
  },

  fetchConsent: ({
    commit
  }, consentId) => {
    consentService.fetchConsent(consentId).then(result => {
      let consent = result.data;
      commit('SET_CONSENT', consent);
    })
  },

  editConsent: ({
    commit
  }, editConsent) => {
    consentService.updateConsent(editConsent).then(result => {
      const consent = result.data;
      commit('SET_CONSENT', consent)

      this.$toasted.success("Consent Edited Succesfully", {
        icon: "fa-check",
        position: "top-right",
        duration: 2000,
        fullWidth: false
      })
    }).catch(error => {
      const message =
        error.response.data.message == undefined ?
        "Something went wrong" :
        error.response.data.message;

      this.$toasted.error(message, {
        icon: "fa-close",
        position: "top-right",
        duration: 2000,
        fullWidth: false
      });
    })
  },

  isInForm: ({
    commit
  }, mode) => {
    consentService.isInForm(mode).then(result => {
      let data = result.data

      const consents = data.consentsDTO
      commit('SET_CONSENTS_ARRAY', consents)
    })
  },

  filterConsents: ({
    commit
  }, filters) => {
    consentService.filterConsents(filters).then(result => {
      let consents = result.data.filterResults;
      consents.forEach(consent => {
        consent.createdDate = new Date(consent.createdDate).toLocaleDateString('en-GB')
      })

      commit('SET_CONSENTS_ARRAY', consents)
    })
  },

  addConsent: ({
    commit
  }, consent) => {
    commit("PUSH_CONSENT", consent);
  },

  removeConsent({
    commit
  }, idx) {
    commit('REMOVE_CONSENT', idx);
  },

  setConsents: ({
    commit
  }, consents) => {
    commit('SET_CONSENTS_ARRAY', consents)
  },

  setConsent: ({
    commit
  }, consent) => {
    commit('SET_CONSENT', consent)
  },

  clearConsents: ({
    commit
  }) => {
    commit('SET_CONSENTS_ARRAY', [])
  },

  clearConsent: ({
    commit
  }) => {
    commit('SET_CONSENT', {})
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
